import React from 'react';
import DefaultComumMessage from '../../Messages/DefaultComumMessage';

const ConfirmFinalizarModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <DefaultComumMessage
      msg="Você tem certeza que deseja finalizar este pedido?"
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};

export default ConfirmFinalizarModal;

